// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.previous-export-list {\n  max-height: calc(90vh - 140px);\n  overflow-y: auto;\n  background-color: unset\n}\n", ""]);
// Exports
module.exports = exports;
